<template>
  <div>

    <gallery :input="propsPhotos" :index="propsPhotosIndex" @close="propsPhotosIndex = null"></gallery>
    <b-modal 
      ref="propsModal" 
      hide-header 
      centered 
      @show="propsShow" 
      :ok-only="!showButtons"
      :modalClass="'props-modal'"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="noCloseOnEsc"
      @hide="propsHidden">
      <!-- @hide="$emit('props-close')"> -->
      <!-- <button type="button" aria-label="Close" class="close" @click="$refs.propsModal.hide()">×</button> -->
      <h5 v-if="!showButtons" class="text-center">{{$t('props')}}</h5>
      <p v-if="showButtons" class="header-info">
        {{$t('pr_props_limit2_01')}}{{getUserProfile.propsLimit}}{{$t('pr_props_limit2_02')}}
      </p>
      <div v-if="propsList && propsList.length" class="props-frame">
        <b-card v-for="(prop, propIndex) in propsList" :key="propIndex" class="props-block">
          <button v-if="showButtons" type="button" aria-label="Close" class="close" :title="$t('deleteProps')" style="color: red;" @click="propsList.splice(propIndex,1)">×</button>
          <!-- <button v-if="showButtons" type="button" aria-label="Close" class="close" :title="$t('deleteProps')" style="color: red;" @click="deleteProp(prop, propIndex)">×</button> -->
          {{$t('title')}}
          <input type="text" class="form-control" v-model="prop.name" required="true" :disabled="!showButtons"/>
          <b-row>
            <div>
              <b-col class="label-size">{{$t('text32')}}</b-col>
              <b-col>
                <b-row>
                  <b-col>
                    {{$t('height')}}
                    <input type="text" class="form-control" v-model="prop.height" required="true" :disabled="!showButtons"/>
                    {{$t('length')}}
                    <input type="text" class="form-control" v-model="prop.length" required="true" :disabled="!showButtons"/>
                  </b-col>
                  <b-col>
                    {{$t('width')}}
                    <input type="text" class="form-control" v-model="prop.width" required="true" :disabled="!showButtons"/>
                    {{$t('weight')}}
                    <input type="text" class="form-control" v-model="prop.weight" required="true" :disabled="!showButtons"/>
                  </b-col>
                </b-row>
                {{$t('requirements')}}
                <input type="text" class="form-control" v-model="prop.requirements" required="true" :disabled="!showButtons"/>
              </b-col>
            </div>
            <!-- <b-col>
              <b-card>
                <b-row>
                  <b-col>
                    {{$t('height')}}
                    <input type="number" class="form-control" v-model="prop.transportSize.height" required="true"/>
                    {{$t('length')}}
                    <input type="number" class="form-control" v-model="prop.transportSize.length" required="true"/>
                  </b-col>
                  <b-col>
                    {{$t('width')}}
                    <input type="number" class="form-control" v-model="prop.transportSize.width" required="true"/>
                    {{$t('weight')}}
                    <input type="number" class="form-control" v-model="prop.transportSize.weight" required="true"/>
                  </b-col>
                </b-row>
                {{$t('requirements')}}
                <input type="text" class="form-control" v-model="prop.transportSize.requirements" required="true"/>
              </b-card>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col v-for="(photo, index) in prop.photos" :key="index" class="text-center image-select">
              <button v-if="showButtons" type="button" aria-label="Close" class="close" :title="$t('deleteImage')" @click="prop.photos.splice(index,1)">×</button>
              <img class="attached-img" :src="photo.href" @click="galleryOpen(prop.photos, index)"/>
            </b-col>
            <b-col class="image-select" v-if="showButtons && (!prop.photos || !prop.photos.length || prop.photos.length<3)">
              <div @click="$refs.fileInput[0].click()" class="image-select-view trigger">
                {{$t('text35')}}
              </div>
              <input type="file" style="display: none;" ref="fileInput" accept="image/*" @change="selectPropImage($event,prop)"/>
            </b-col>
            <b-col v-if="!prop.photos || !prop.photos.length || prop.photos.length<2">
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div class="props-footer">
        <div class="footer-btns">
          <div class="force-left">
            <button v-if="showButtons" class="btn btn-info btn-fill btn-add-props" @click="addProps()">{{$t('addProps')}}</button>
          </div>
          <div class="force-right">
            <button ref="cancel" class="btn btn-secondary btn-fill btn-props" @click="$refs.propsModal.hide()">{{$t('props_close')}}</button>
            <button v-if="showButtons" class="btn btn-primary btn-fill btn-props" @click="handleOk($event)">{{$t('props_apply')}}</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import gallery from 'gallery-vue';
  import swal from 'sweetalert2';
  import cloneDeep from 'clone-deep';
  import { USER_GALLERY_IMAGE } from "../store/actions/userConst"
  import { mapActions, mapGetters } from 'vuex';

  export default {
    components: { gallery },
    props: {
      propsList: {},
      modalShow: false,
      showButtons: true,
    },
    data() {
      return {
        noCloseOnEsc: false,
        okClick: false,
        propsBuf: [],
        propsPhotos: [],
        propsPhotosIndex: null,
        toast: swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
      }
    },
    watch: {
      modalShow(val) {
        if(val) this.$refs.propsModal.show()
      },
      propsList() {
        if (this.propsList && this.propsList.length) {
          for (let i = 0, len = this.propsList.length; i < len; i++) {
            for (let j = 0, leng = this.propsList[i].photos.length; j < leng; j++) {
              if (this.propsList[i].photos[j].photoId && !this.propsList[i].photos[j].href && !this.propsList[i].photos[j].loaded) {
                this.propsList[i].photos[j].loaded = true;
                this.USER_GALLERY_IMAGE({id: this.propsList[i].photos[j].photoId})
                  .then(res=> {
                    delete this.propsList[i].photos[j].loaded;
                    if(res.success) {
                      this.propsList[i].photos[j].href = res.data.href;
                      this.propsList.unshift({});
                      this.propsList.splice(0,1);
                    } else {
                      console.log('Error get image ' + this.propsList[i].photos[j].photoId);
                    }
                  })
                  .catch(err=>{
                    console.log(err);
                    delete this.propsList[i].photos[j].loaded;
                  });
              }
            }
          }
        }
      },
    },
    computed: {
      ...mapGetters(['getUserProfile'])
    },
    methods: {
      ...mapActions([USER_GALLERY_IMAGE]),
      deleteProp(prop, propIndex) {
        if(prop.added) {
          this.propsList.splice(propIndex,1)
        } else {
          prop.deleted=true
          this.propsList.unshift({})
          this.propsList.splice(0,1)
        }
      },
      galleryOpen(photos, index) {
        this.propsPhotos = []
        photos.forEach(photo => {
          this.propsPhotos.push(photo.href)
        })
        this.propsPhotosIndex = index
      },
      selectPropImage(evt,prop) {
        let reader = new FileReader()
        reader.onload = (e) => {
          prop.photos.push({file: evt.target.files[0], href: e.target.result})
        }
        reader.readAsDataURL(evt.target.files[0])
      },
      propsShow() {
        this.propsBuf = cloneDeep(this.propsList);
        if (!this.propsList.length) {
            this.propsList.unshift({height: 0, length: 0, weight: 0, width: 0, requirements: null, transportSize: {}, photos: []})
        }
      },
      propsHidden() {
        if(this.okClick) {
          this.okClick = false
        } else {
          this.$emit('props-update',this.propsBuf)
        }
        this.$emit('props-close');
        // this.propsPhotosIndex = null
        // this.$refs.propsModal.hide();
      },
      handleOk(evt) {
        let unValidateProps = this.propsList.filter(p=>!p.name || !p.name.length)
        if(unValidateProps.length) {
          evt.preventDefault();
          this.noCloseOnEsc = true;
          swal.fire({
            text: this.$t('text34'),
            type: 'error',
          }).then(()=>this.noCloseOnEsc = false);
        } else {
          this.okClick = true;
          // this.propsHidden()
          this.$refs.propsModal.hide();
        }
        this.$emit('props-close');
      },
      addProps() {
        if (this.propsList.length < this.getUserProfile.propsLimit) {
          this.propsList.unshift({height: 0, length: 0, weight: 0, width: 0, requirements: null, transportSize: {}, photos: []})
        } else {
          this.toast.fire({
            title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_props_limit3') + this.getUserProfile.propsLimit + this.$t('pr_props_limit2_02')
          });
        }
      },
    },
  }
</script>

<style>
.props-modal > div {
    position: fixed;
    left: 0; right: 0;
    top: 0px;
}
.props-modal .modal-content {
    opacity: 1 !important;
    position: absolute !important;
}
@media only screen and (max-width: 768px) {
    .props-modal {
      padding: 0 !important;
    }
    .props-modal .modal-dialog {
      margin: 0 !important;
    }
}
</style>

<style scoped>
.header-info {
  display: inline-block;
  margin-bottom: 0px;
}
.btn-add-props {
  background-color: #FB404B !important;
  border-color: #FB404B !important;
  font-weight: 500 !important;
  display: inline-block;
  height: 30px;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-props {
  font-weight: 500 !important;
  display: inline-block;
  height: 30px;
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}

.image-select-view {
  width: 100px;
  height: 100px;
  background-color: grey;
  cursor: pointer;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  padding: 8px;
  border-radius: 0.25rem;
  color: #efefef;
  text-shadow: 1px 1px 1px #000000d6;
}
.image-select {
  margin-top: 10px;
}
.props-footer {
  margin-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.footer-btns {
  margin-top: 10px;
}
.footer-btns .btn-secondary {
  margin-right: 5px;
}
.label-size {
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
}
.close {
  color: red;
  position: relative;
  top: -8px;
}
.props-block {
  margin-bottom: 10px;
}
.props-frame {
  min-height: 200px;
  max-height: 445px;
  overflow-y: auto;
  margin-top: 1em;
}
.attached-img {
  max-width: 100px;
  max-height: 100px;
  cursor: pointer;
  border-radius: 4px;
}
::-webkit-scrollbar {
  width: 8px
}
@media only screen and (max-width: 768px) {
    .subscription h1 {
        text-align: center;
    } 
  .props-frame {
    height: calc(100vh - 220px);
  }
}
</style>

